import { Check, CircleAlert, Info, X, type LucideIcon } from 'lucide-react';
import { useUiStore } from '@/store/uiStore';

const toneStyles: Record<'success' | 'error' | 'info', { disc: string; Icon: LucideIcon }> = {
  success: { disc: 'bg-success/20 text-success', Icon: Check },
  error: { disc: 'bg-danger/20 text-danger', Icon: CircleAlert },
  info: { disc: 'bg-info/20 text-info', Icon: Info },
};

/** UI_GUIDELINES §5 Toast. */
export function ToastStack() {
  const toasts = useUiStore((s) => s.toasts);
  const dismissToast = useUiStore((s) => s.dismissToast);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => {
        const { disc, Icon } = toneStyles[toast.variant];
        return (
          <div
            key={toast.id}
            role="status"
            className="animate-slide-up flex items-center gap-3 rounded-card border border-line-strong bg-surface-3 py-2.5 pl-3 pr-2 text-[13px] text-fg shadow-card"
          >
            <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${disc}`} aria-hidden="true">
              <Icon size={12} strokeWidth={2.5} />
            </span>
            <span className="min-w-0 flex-1">{toast.message}</span>
            <button
              type="button"
              onClick={() => dismissToast(toast.id)}
              className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-control text-fg-muted transition-colors duration-fast hover:bg-surface-2 hover:text-fg"
              aria-label="Opusti"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
